import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { createStore } from "vuex-extensions";
import { getModule } from "vuex-module-decorators";
import { namespace } from "vuex-class";

import { Auth, AuthState } from "./modules/auth";
import TermsManagement from "./modules/terms-management";
import Survey from "./modules/survey";
import { App } from "./modules/app";

import { state, State, getters, mutations } from "./root";

Vue.use(Vuex);

export interface RootState extends State {
  auth: AuthState;
}

const debug = process.env.NODE_ENV !== "production";

const vuexLocalStorage = new VuexPersistence<RootState>({
  strictMode: debug,
  key: "vuex",
  storage: window.localStorage,
  modules: ["auth"],
  filter: ({ type }) => {
    return (
      type.includes("login") ||
      ["auth/logout", "reset", "auth/setProfile", "auth/loginSuccess", "auth/setLoading"].includes(type)
    );
  },
});

const store = createStore<RootState>(Vuex.Store, {
  state: { ...state } as RootState,
  getters,
  mutations: {
    ...mutations,
    RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION,
  },
  modules: {
    app: App,
    auth: Auth,
    termsmanagement: TermsManagement,
    survey: Survey,
  },
  plugins: [vuexLocalStorage.plugin],
  strict: debug,
});

export default store;

// quando si esegue il logout esegue il reset dello state dell'intera applicazione
store.subscribe(action => {
  if (action.type === "auth/logout") {
    store.reset();
  }
});

export const AuthModule = {
  store: getModule(Auth, store),
  bindings: namespace("auth"),
};

export const TermsManagementModule = {
  store: getModule(TermsManagement, store),
  bindings: namespace("termsmanagement"),
};

export const SurveyModule = {
  store: getModule(Survey, store),
  bindings: namespace("survey"),
};

export const AppModule = {
  store: getModule(App, store),
  bindings: namespace("app"),
};
